import { QueryResult } from "@apollo/client";
import { Stack } from "@mui/material";
import { EventStatusPill } from "components/layout/event/EventStatusPill";
import {
    GetEventsByNameQuery
} from "components/layout/home/SearchEventAndOrganisation.gql.types";
import { EventCard } from "components/routes/root/eventCard/EventCard";
import { EventCardDate } from "components/routes/root/eventCard/EventCardDate";
import { EventCardMainSection } from "components/routes/root/eventCard/EventCardMainSection";
import { EventCardOrganisation } from "components/routes/root/eventCard/EventCardOrganisation";
import { EventCardTitle } from "components/routes/root/eventCard/EventCardTitle";
import { eventCardDate } from "models/Event";

type SearchEvent = NonNullable<
    NonNullable<QueryResult<GetEventsByNameQuery>["data"]>["eventsByName"]
>[number];

export const SearchEventCard: React.FC<{ event: SearchEvent }> = ({
    event,
}) => {
    return (
        <EventCard fullWidth>
            <EventCardMainSection status={event.status}>
                <Stack
                    direction="row"
                    spacing={2}
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <EventCardDate date={eventCardDate(event, true)} />
                    <EventStatusPill status={event.status} />
                </Stack>
                <EventCardTitle title={event.name} />
            </EventCardMainSection>
            <EventCardOrganisation
                organisation={event.organisation}
                logo={true}
                status={event.status}
            />
        </EventCard>
    );
};
